import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  right: -20px;
  top: -10px;
  cursor: pointer;
  padding: 5px 10px;
`;